<template>
  <v-container fluid>
    <v-layout v-if="!tableStyle" class="clsScroll">
      <v-flex>
        <!-- Dialog for Add View Edit -->
        <action-dialog
          :type="dialogType"
          :title="title"
          :dialog="dialogStatus"
          @closeDialog="closeDialog"
          :loading="dialogLoading"
        >
          <v-container grid-list-xs>
            <v-layout>
              <v-flex md8 offset-md2>
                <v-card class="elevation-7">
                  <table
                    id="viewTable"
                    v-for="item in viewItems"
                    :key="item.id"
                  >
                    <tr>
                      <td class="propertyName">Merchant Code:</td>
                      <td
                        :class="[
                          'text-xs-left',
                          item.transaction_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{ item.merchant }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Device Serial:</td>
                      <td
                        :class="[
                          'text-xs-left',
                          item.transaction_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{ item.device_serial }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Branch:</td>
                      <td
                        :class="[
                          'text-xs-left',
                          item.transaction_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{ item.terminal }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">TRX #:</td>
                      <td
                        :class="[
                          'text-xs-left',
                          item.transaction_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{ item.transaction_no }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Date:</td>
                      <td
                        :class="[
                          'text-xs-center',
                          item.transaction_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{ $dateFormat(item.transaction_date, "YYYY-MM-DD") }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Cashier Name:</td>
                      <td
                        :class="[
                          'text-xs-left',
                          item.transaction_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.cashier_name === null ? "--" : item.cashier_name
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Trace No. (W):</td>
                      <td
                        :class="[
                          'text-xs-left',
                          item.transaction_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.trace_no_wireless === null
                            ? "--"
                            : item.trace_no_wireless
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Card No. (W):</td>
                      <td
                        :class="[
                          'text-xs-left',
                          item.transaction_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.card_no_wireless === null
                            ? "--"
                            : item.card_no_wireless
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Type (W):</td>
                      <td
                        :class="[
                          'text-xs-left',
                          item.transaction_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.type_wireless === null
                            ? "--"
                            : item.type_wireless.toUpperCase()
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Amount (W):</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.transaction_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.card_amount_wireless === null
                            ? "--"
                            : $amountInPeso(item.card_amount_wireless)
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Trace No. (S):</td>
                      <td
                        :class="[
                          'text-xs-left',
                          item.transaction_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.trace_no_sync === null
                            ? "--"
                            : item.trace_no_sync
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Card No. (S):</td>
                      <td
                        :class="[
                          'text-xs-left',
                          item.transaction_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.card_no_sync === null ? "--" : item.card_no_sync
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Type (S):</td>
                      <td
                        :class="[
                          'text-xs-left',
                          item.transaction_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.type_sync === null
                            ? "--"
                            : item.type_sync.toUpperCase()
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Amount (S):</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.transaction_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.card_amount_sync === null
                            ? "--"
                            : $amountInPeso(item.card_amount_sync)
                        }}
                      </td>
                    </tr>
                    <tr>
                      <td class="propertyName">Discrepancy:</td>
                      <td
                        :class="[
                          'text-xs-right',
                          item.transaction_status != 0 ? 'theError' : '',
                        ]"
                      >
                        {{
                          item.discrepancy === null
                            ? "--"
                            : $amountInPeso(item.discrepancy)
                        }}
                      </td>
                    </tr>
                  </table>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </action-dialog>

        <v-divider></v-divider>
        <v-data-table
          :headers="headers"
          :items="theData"
          hide-actions
          disable-initial-sort
        >
          <template slot="headers" slot-scope="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                :class="[
                  'column sortable',
                  header.value === queryParams.order ? 'active' : '',
                  'text-xs-' + header.align,
                ]"
                :style="
                  header.text == 'Amount (W)'
                    ? 'border-right: 2px solid #757575;'
                    : header.text == 'Amount (S)'
                    ? 'border-right: 2px solid #757575;'
                    : header.text == 'Trace No. (W)'
                    ? 'border-left: 2px solid #757575;'
                    : header.text == 'Trace No. (S)'
                    ? 'border-left: 2px solid #757575;'
                    : header.text == 'Discrepancy'
                    ? 'border-left: 2px solid #757575;'
                    : header.text == 'Cashier Name'
                    ? 'border-left: 2px solid #757575;'
                    : ''
                "
              >
                <span v-if="header.text == 'Date'" @click="sortByDate">
                  {{ header.text }}
                  <v-icon>{{
                    toggleStatus ? "arrow_downward" : "arrow_upward"
                  }}</v-icon>
                </span>
                <span v-else>{{ header.text }}</span>
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <td
              :class="[
                'text-xs-center',
                props.item.transaction_status != 0 ? 'theError' : '',
              ]"
            >
              {{ props.index + 1 }}
            </td>
            <td
              :class="[
                'text-xs-center no-wrap',
                props.item.transaction_status != 0 ? 'theError' : '',
              ]"
            >
              <!-- <v-tooltip top>
                <v-btn
                  icon
                  small
                  slot="activator"
                  style="height: 16px; width: 15px;"
                  @click="openDialog(props.item)"
                >
                  <v-icon color="blue">find_in_page</v-icon>
                </v-btn>
                <span>View</span>
              </v-tooltip> -->

              <v-tooltip top>
                <v-btn
                  class="ma-0 pa-0"
                  icon
                  small
                  slot="activator"
                  style="height: 16px; width: 15px;"
                  v-if="
                    $moduleAccess('align_transaction_report') &&
                      props.item.transaction_status === 3
                  "
                  @click="syncToWireless(props.item)"
                >
                  <v-icon color="teal">swap_horiz</v-icon>
                </v-btn>
                <span>Align</span>
              </v-tooltip>
            </td>
            <td
              :class="[
                'text-xs-left text-uppercase',
                props.item.transaction_status != 0 ? 'theError' : '',
              ]"
            >
              {{ props.item.merchant }}
            </td>
            <td
              :class="[
                'text-xs-left',
                props.item.transaction_status != 0 ? 'theError' : '',
              ]"
              class="text-xs-left"
            >
              {{ props.item.device_serial }}
            </td>
            <td
              :class="[
                'text-xs-left text-uppercase text-no-wrap',
                props.item.transaction_status != 0 ? 'theError' : '',
              ]"
            >
              {{ props.item.terminal }}
            </td>
            <td
              :class="[
                'text-xs-left text-uppercase',
                props.item.transaction_status != 0 ? 'theError' : '',
              ]"
            >
              {{ props.item.transaction_no }}
            </td>
            <td
              :class="[
                'text-xs-center no-wrap',
                props.item.transaction_status != 0 ? 'theError' : '',
              ]"
            >
              {{ $dateFormat(props.item.transaction_date, "YYYY-MM-DD") }}
            </td>
            <td
              :class="[
                'text-xs-center no-wrap',
                props.item.transaction_status != 0 ? 'theError' : '',
              ]"
            >
              {{ $dateFormat(props.item.transaction_date, "HH:mm:ss") }}
            </td>

            <td
              :class="[
                'text-xs-left',
                props.item.transaction_status != 0 ? 'theError' : '',
              ]"
              style="border-left: 2px solid #757575;"
            >
              {{
                props.item.trace_no_wireless === null
                  ? "--"
                  : props.item.trace_no_wireless
              }}
            </td>
            <td
              :class="[
                'text-xs-left',
                props.item.transaction_status != 0 ? 'theError' : '',
              ]"
            >
              {{
                props.item.card_no_wireless === null
                  ? "--"
                  : props.item.card_no_wireless
              }}
            </td>
            <td
              v-if="props.item.type_wireless != null"
              :class="[
                'text-xs-left text-uppercase text-no-wrap',
                props.item.transaction_status != 0 ? 'theError' : '',
              ]"
            >
              {{ props.item.type_wireless }}
            </td>
            <td
              v-if="props.item.type_wireless === null"
              :class="[
                'text-xs-left text-uppercase',
                props.item.transaction_status != 0 ? 'theError' : '',
              ]"
            >
              {{ "--" }}
            </td>
            <td
              :class="[
                'text-xs-right',
                props.item.transaction_status != 0 ? 'theError' : '',
              ]"
              style="border-right: 2px solid #757575;"
            >
              {{
                props.item.card_amount_wireless === null
                  ? "--"
                  : $amountInPeso(props.item.card_amount_wireless)
              }}
            </td>
            <td
              :class="[
                'text-xs-left',
                props.item.transaction_status != 0 ? 'theError' : '',
              ]"
              style="border-left: 2px solid #757575;"
            >
              {{
                props.item.trace_no_sync === null
                  ? "--"
                  : props.item.trace_no_sync
              }}
            </td>
            <td
              :class="[
                'text-xs-left',
                props.item.transaction_status != 0 ? 'theError' : '',
              ]"
            >
              {{
                props.item.card_no_sync === null
                  ? "--"
                  : props.item.card_no_sync
              }}
            </td>
            <td
              v-if="props.item.type_sync != null"
              :class="[
                'text-xs-left text-uppercase text-no-wrap',
                props.item.transaction_status != 0 ? 'theError' : '',
              ]"
            >
              {{ props.item.type_sync }}
            </td>
            <td
              v-if="props.item.type_sync === null"
              :class="[
                'text-xs-left text-uppercase',
                props.item.transaction_status != 0 ? 'theError' : '',
              ]"
            >
              {{ "--" }}
            </td>
            <td
              :class="[
                'text-xs-right',
                props.item.transaction_status != 0 ? 'theError' : '',
              ]"
              style="border-right: 2px solid #757575;"
            >
              {{
                props.item.card_amount_sync === null
                  ? "--"
                  : $amountInPeso(props.item.card_amount_sync)
              }}
            </td>
            <td
              :class="[
                'text-xs-right',
                props.item.transaction_status != 0 ? 'theError' : '',
              ]"
              style="border-left: 2px solid #757575;"
            >
              {{
                props.item.discrepancy === null
                  ? "--"
                  : $amountInPeso(props.item.discrepancy)
              }}
            </td>
            <td
              :class="[
                'text-xs-left no-wrap text-no-wrap',
                props.item.transaction_status != 0 ? 'theError' : '',
              ]"
              style="border-left: 2px solid #757575;"
            >
              {{
                props.item.cashier_name === null
                  ? "--"
                  : props.item.cashier_name
              }}
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <!--- This is the Grid Style Table --->

    <transaction-reports-native
      v-if="tableStyle"
      :items="theData"
      :title="title"
      :toggStatus="toggleStatus"
      style="padding: 0px;"
      @toggleDate="sortByDate"
      @sync="syncToWireless"
    ></transaction-reports-native>
  </v-container>
</template>

<script>
import TransactionReportsNative from "@/components/tripko/ExceptionReports/TransactionReportsNative";

var now = new Date();

export default {
  components: {
    TransactionReportsNative,
  },
  props: {
    items: Array,
    tableStyle: Boolean,
    headers: Array,
    title: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      queryParams: {
        search: "",
        transaction_id: null,
        type: null,
      },
      dateFrom: this.$dateFormat(now, "YYYY-MM-DD"),
      dateTo: this.$dateFormat(now, "YYYY-MM-DD"),
      toggleStatus: false,
      dialogLoading: false,
      dialogType: "",
      dialogStatus: false,
      viewItems: [],
      viewHeaders: [
        {
          text: "Merchant Code",
          align: "left",
          value: "control_no",
          sortable: true,
        },
        {
          text: "Device Serial",
          align: "left",
          value: "transaction_id",
          sortable: true,
        },
        {
          text: "Branch",
          align: "left",
          value: "seat_id",
          sortable: true,
        },
        {
          text: "TRX #",
          align: "center",
          value: "transaction_no",
          sortable: false,
        },
        {
          text: "Date",
          align: "center",
          value: "km_post_id",
          sortable: true,
        },
        {
          text: "Trace No. (W)",
          align: "left",
          value: "trace_no",
          sortable: false,
        },
        {
          text: "Card No. (W)",
          align: "left",
          value: "card_no",
          sortable: false,
        },
        {
          text: "Type (W)",
          align: "left",
          value: "type",
          sortable: false,
        },
        {
          text: "Amount (W)",
          align: "right",
          value: "amount",
          sortable: false,
        },
        {
          text: "Trace No. (S)",
          align: "left",
          value: "trace_no",
          sortable: false,
        },
        {
          text: "Card No. (S)",
          align: "left",
          value: "card_no",
          sortable: false,
        },
        {
          text: "Type (S)",
          align: "left",
          value: "type",
          sortable: false,
        },
        {
          text: "Amount (S)",
          align: "right",
          value: "amount",
          sortable: false,
        },
        {
          text: "Discrepancy",
          align: "right",
          value: "amount",
          sortable: false,
        },
      ],
    };
  },
  computed: {
    theData() {
      let theData = [];
      let aNewArray = [];

      this.items.forEach((item) => {
        aNewArray.push(item);
      });

      if (this.toggleStatus == true) {
        let dateASC = aNewArray.sort(function(a, b) {
          var dateA = new Date(a.transaction_date),
            dateB = new Date(b.transaction_date);
          return dateA - dateB;
        });

        dateASC.forEach((data) => {
          theData.push(data);
        });

        return theData;
      } else if (this.toggleStatus == false) {
        let dateDESC = aNewArray.sort(function(a, b) {
          var dateA = new Date(a.transaction_date),
            dateB = new Date(b.transaction_date);
          return dateB - dateA;
        });

        dateDESC.forEach((data) => {
          theData.push(data);
        });

        return theData;
      } else {
        return this.items;
      }
    },
  },
  methods: {
    sortByDate() {
      this.toggleStatus = !this.toggleStatus;
    },
    syncToWireless(data) {
      this.$emit("sync", data);
    },
    openDialog(data) {
      this.dialogLoading = true;

      this.dialogType = "view";
      this.dialogStatus = true;

      this.viewItems = [];

      this.viewItems.push(data);

      setTimeout(() => {
        this.dialogLoading = false;
      }, 600);
    },
    closeDialog() {
      this.dialogType = "";
      this.dialogStatus = false;
    },
  },
};
</script>

<style scoped>
#viewTable {
  font-family: "Trebuchet MS", Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#viewTable td,
#viewTable th {
  border: 2px solid #000;
  padding: 8px;
}

.propertyName {
  background-color: rgb(241, 241, 241);
  font-weight: bold;
}

.theError {
  color: red;
  font-weight: bold;
}

.table-controls {
  padding: 0 !important;
}
table.v-table td,
th {
  box-shadow: 1px 0px 0px 0px #eee;
}
table.v-table tbody tr {
  cursor: pointer !important;
}
.current-row {
  background-color: #ddd;
}
.row-active {
  box-shadow: 4px -1px 0px 0px rgb(76, 175, 80) inset;
}
.row-inactive {
  color: rgb(244, 67, 54);
  box-shadow: 4px 0px 0px 0px rgb(244, 67, 54) inset;
}
table.v-table td,
th {
  height: 30px !important;
  padding: 0px 5px 0px 5px !important;
}
table.v-table thead tr:not(.v-datatable__progress) {
  height: 30px;
}
table.v-table th {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
</style>
